import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ViewPatient = ({ toggleSidebar }) => {
  const [patientData, setPatientData] = useState({
    patient_id: "",
    registration_date: "",
    first_name: "",
    last_name: "",
    age: "",
    date_of_birth: "",
    gender: "",
    marital_status: "",
    spouse_name: "",
    mobile_no: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    referred_by: "",
    id_proof_type: "",
    scan_findings: "",
    siemen_analysis: "",
    id_proof_no: "",
    bp_level: "",
    sugar_level: "",
    purpose: "",
    notes: "",
    status: "",
    blood_group: "",
    height_cm: "",
    weight_kg: "",
    menstrual: "",
    yoga_status: "",
    treatment_status: "",
    patient_type: "",
    homeo_bp: "",
    pluse: "",
    married_for_year: "",
    type_of_yoga: "",
    consiquence: "",
    sexual_histroy: "",
    medical_histroy: "",
    previous_histroy: "",
    family_histroy: "",
    current_mediatation: "",
    breast: "",
    tyroid: "",
    per_abutamon: "",
    per_speculum: "",
    per_virginal_exam: "",
    diagonsis: "",
    plan_of_treatment: "",
    advise: "",
    report_type: "",
    next_review_date: "",
    homeo_bp: "",
    homeo_sugar: "",
    homeo_height: "",
    homeo_heart_rate: "",
    homeo_blood_test: "",
    homeo_electriohomeogram: "",
    homeo_stress_test: "",
    homeo_echohomeogram: "",
    homeo_scan_type: "",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const patient = location.state?.patient;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  useEffect(() => {
    if (patient) {
      setPatientData({
        patient_id: patient.patient_id || "",
        registration_date: patient.registration_date || "",
        first_name: patient.first_name || "",
        last_name: patient.last_name || "",
        age: patient.age || "",
        date_of_birth: patient.date_of_birth || "",
        gender: patient.gender || "",
        marital_status: patient.marital_status || "",
        spouse_name: patient.spouse_name || "",
        mobile_no: patient.mobile_no || "",
        sugar_level: patient.sugar_level || "",
        bp_level: patient.bp_level || "",
        purpose: patient.purpose || "",
        email: patient.email || "",
        address: patient.address || "",
        city: patient.city || "",
        state: patient.state || "",
        pincode: patient.pincode || "",
        referred_by: patient.referred_by || "",
        id_proof_type: patient.id_proof_type || "",
        id_proof_no: patient.id_proof_no || "",
        notes: patient.notes || "",
        status: patient.status || "",
        blood_group: patient.blood_group || "",
        height_cm: patient.height_cm || "",
        weight_kg: patient.weight_kg || "",
        menstrual: patient.menstrual || "",
        yoga_status: patient.yoga_status || "",
        treatment_status: patient.treatment_status || "",
        patient_type: patient.patient_type || "",
        pluse: patient.pluse || "",
        married_for_year: patient.married_for_year || "",
        type_of_yoga: patient.type_of_yoga || "",
        consiquence: patient.consiquence || "",
        sexual_histroy: patient.sexual_histroy || "",
        medical_histroy: patient.medical_histroy || "",
        previous_histroy: patient.previous_histroy || "",
        family_histroy: patient.family_histroy || "",
        current_mediatation: patient.current_mediatation || "",
        scan_findings: patient.scan_findings || "",
        siemen_analysis: patient.siemen_analysis || "",
        breast: patient.breast || "",
        tyroid: patient.tyroid || "",
        per_abutamon: patient.per_abutamon || "",
        per_speculum: patient.per_speculum || "",
        per_virginal_exam: patient.per_virginal_exam || "",
        diagonsis: patient.diagonsis || "",
        plan_of_treatment: patient.plan_of_treatment || "",
        advise: patient.advise || "",
        report_type: patient.report_type || "",
        next_review_date: patient.next_review_date || "",
        homeo_bp: patient.homeo_bp || "",
        homeo_sugar: patient.homeo_sugar || "",
        homeo_height: patient.homeo_height || "",
        homeo_heart_rate: patient.homeo_heart_rate || "",
        homeo_blood_test: patient.homeo_blood_test || "",
        homeo_electriohomeogram: patient.homeo_electriohomeogram || "",
        homeo_stress_test: patient.homeo_stress_test || "",
        homeo_echohomeogram: patient.homeo_echohomeogram || "",
        homeo_scan_type: patient.homeo_scan_type || "",
      });
    } else {
      navigate("/patients"); // Redirect if no patient data
    }
  }, [patient, navigate]);

  const handleBack = () => {
    toggleSidebar();

    if (patient.patient_type === "Yoga") {
      navigate("/patients/yoga-patients");
    } else if (patient.patient_type === "Homeopathy") {
      navigate("/patients/homeopathy-patients");
    } else {
      navigate("/patients/homeopathy_patients");
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-start py-2">
      <div className="card w-100 p-4">
        {/* Basic Details - Always shown */}
        <div className="border border-1 border-secondary p-1 bg-white">
          <div className="mb-3 text-center">
            <h4 className="fw-bold text-dark">
              <span style={{ color: "#01AEBE" }}>Basic</span> Details
            </h4>
          </div>
          <div className="container-fulid px-2">
            <div className="row">
              {[
                { label: "Patient ID", value: patientData.patient_id || "-" },
                {
                  label: "Registration Date",
                  value: patientData.registration_date || "-",
                },
                { label: "First Name", value: patientData.first_name || "-" },
                { label: "Last Name", value: patientData.last_name || "-" },
                {
                  label: "Date of Birth",
                  value: patientData.date_of_birth || "-",
                },
                { label: "Age", value: patientData.age || "-" },
                {
                  label: "Gender",
                  value: patientData.gender || "Not Provided",
                },
                {
                  label: "Marital Status",
                  value: patientData.marital_status || "Not Provided",
                },
                { label: "Spouse Name", value: patientData.spouse_name || "-" },
                { label: "Mobile Number", value: patientData.mobile_no || "-" },
                {
                  label: "ID Proof Type",
                  value: patientData.id_proof_type || "Not Provided",
                },
                {
                  label: "ID Proof Number",
                  value: patientData.id_proof_no || "-",
                },
                { label: "Email", value: patientData.email || "-" },
                { label: "Address", value: patientData.address || "-" },
                { label: "City", value: patientData.city || "-" },
                { label: "State", value: patientData.state || "Not Provided" },
                { label: "Pincode", value: patientData.pincode || "-" },
                {
                  label: "Patient Type",
                  value: patientData.patient_type || "-",
                },
                { label: "Purpose", value: patientData.purpose || "-" },
                { label: "Notes", value: patientData.notes || "-" },
              ].map((item, index) => (
                <div className="col-md-3 mb-3" key={index}>
                  <div
                    className="rounded p-1 bg-light"
                    style={
                      item.label === "Notes"
                        ? {
                            maxHeight: "3.2em",
                            overflowY: "auto",
                            whiteSpace: "pre-wrap",
                          }
                        : {}
                    }
                  >
                    {item.label} : <strong>{item.value}</strong>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Yoga Sections - Only shown for Yoga patients */}
        {patientData.patient_type === "Yoga" && (
          <>
            {/* Yoga Details Section */}
            <div className="border border-1 border-secondary p-1 bg-white mt-3">
              <div className="mb-3 text-center">
                <h4 className="fw-bold text-dark">
                  <span style={{ color: "#01AEBE" }}>Yoga</span> Details
                </h4>
              </div>
              <div className="container-fulid px-2">
                <div className="row">
                  {[
                    {
                      label: "Married For (Years)",
                      value: patientData.married_for_year || "-",
                    },
                    {
                      label: "Type of Yoga",
                      value: patientData.type_of_yoga || "Not Provided",
                    },
                    {
                      label: "Consequence",
                      value: patientData.consiquence || "-",
                    },
                    {
                      label: "Menstrual",
                      value: patientData.menstrual || "Not Provided",
                    },
                    {
                      label: "Sexual History",
                      value: patientData.sexual_histroy || "-",
                      isTextarea: true,
                    },
                    {
                      label: "Medical History",
                      value: patientData.medical_histroy || "-",
                      isTextarea: true,
                    },
                    {
                      label: "Previous History",
                      value: patientData.previous_histroy || "-",
                      isTextarea: true,
                    },
                    {
                      label: "Family History",
                      value: patientData.family_histroy || "-",
                      isTextarea: true,
                    },
                    {
                      label: "Current Medication",
                      value: patientData.current_mediatation || "-",
                      isTextarea: true,
                    },
                  ].map((item, index) => (
                    <div className="col-md-3 mb-3" key={index}>
                      <div
                        className="rounded p-1 bg-light"
                        style={
                          item.isTextarea
                            ? {
                                maxHeight: "3.2em",
                                overflowY: "auto",
                                whiteSpace: "pre-wrap",
                              }
                            : {}
                        }
                      >
                        {item.label} : <strong>{item.value}</strong>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Examination Details Section */}
            <div className="border border-1 border-secondary p-1 bg-white mt-3">
              <div className="mb-3 text-center">
                <h4 className="fw-bold text-dark">
                  <span style={{ color: "#01AEBE" }}>Examination</span> Details
                </h4>
              </div>

              <div className="container-fulid px-2">
                <div className="row">
                  {[
                    {
                      label: "Height (cm)",
                      value: patientData.height_cm || "-",
                    },
                    {
                      label: "Weight (kg)",
                      value: patientData.weight_kg || "-",
                    },
                    {
                      label: "Blood Group",
                      value: patientData.blood_group || "Not Provided",
                    },
                    { label: "BP Level", value: patientData.bp_level || "-" },
                    {
                      label: "Sugar Level",
                      value: patientData.sugar_level || "-",
                    },
                    { label: "Pulse", value: patientData.pluse || "-" },
                    { label: "Breast", value: patientData.breast || "-" },
                    { label: "Thyroid", value: patientData.tyroid || "-" },
                    {
                      label: "Per Abdomen",
                      value: patientData.per_abutamon || "-",
                    },
                    {
                      label: "Per Speculum",
                      value: patientData.per_speculum || "-",
                    },
                    {
                      label: "Per Virginal Exam",
                      value: patientData.per_virginal_exam || "-",
                      isLong: true,
                    },
                  ].map((item, index) => (
                    <div className="col-md-3 mb-3" key={index}>
                      <div
                        className="rounded p-1 bg-light"
                        style={
                          item.isLong
                            ? {
                                maxHeight: "3.2em", // approx 2 lines
                                overflowY: "auto",
                                whiteSpace: "pre-wrap",
                              }
                            : {}
                        }
                      >
                        {item.label} : <strong>{item.value}</strong>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Diagnosis Details Section */}
            <div className="border border-1 border-secondary p-1 bg-white mt-3">
              <div className="mb-3 text-center">
                <h4 className="fw-bold text-dark">
                  <span style={{ color: "#01AEBE" }}>Diagnosis</span> Details
                </h4>
              </div>

              <div className="container-fulid px-2">
                <div className="row">
                  {[
                    {
                      label: "Diagnosis",
                      value: patientData.diagonsis || "-",
                      isLong: true,
                    },
                    {
                      label: "Plan of Treatment",
                      value: patientData.plan_of_treatment || "-",
                      isLong: true,
                    },
                    {
                      label: "Advice",
                      value: patientData.advise || "-",
                      isLong: true,
                    },
                    {
                      label: "Scan Findings",
                      value: patientData.scan_findings || "-",
                      isLong: true,
                    },
                    {
                      label: "Semen Analysis",
                      value: patientData.siemen_analysis || "-",
                      isLong: true,
                    },
                    {
                      label: "Next Review Date",
                      value: patientData.next_review_date
                        ? new Date(
                            patientData.next_review_date
                          ).toLocaleDateString()
                        : "-",
                    },
                  ].map((item, index) => (
                    <div className="col-md-3 mb-3" key={index}>
                      <div
                        className="rounded p-1 bg-light"
                        style={
                          item.isLong
                            ? {
                                maxHeight: "3.2em",
                                overflowY: "auto",
                                whiteSpace: "pre-wrap",
                              }
                            : {}
                        }
                      >
                        {item.label} : <strong>{item.value}</strong>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        {/* Homeopathy Details Section - Only shown for Homeopathy patients */}
        {patientData.patient_type === "Homeopathy" && (
          <div className="border border-1 border-secondary p-4 bg-white mt-4">
            <div className="mb-3 text-center">
              <h4 className="fw-bold text-dark">
                <span style={{ color: "#01AEBE" }}>Homeopathy</span> Details
              </h4>
            </div>

            <div className="container-fulid px-2">
              <div className="row">
                {[
                  {
                    label: "Blood Pressure",
                    value: patientData.homeo_bp || "-",
                  },
                  {
                    label: "Sugar Level",
                    value: patientData.homeo_sugar || "-",
                  },
                  {
                    label: "Height (cm)",
                    value: patientData.homeo_height || "-",
                  },
                  {
                    label: "Heart Rate",
                    value: patientData.homeo_heart_rate || "-",
                  },
                  {
                    label: "Blood Test",
                    value: patientData.homeo_blood_test || "-",
                  },
                  {
                    label: "Electrohomeogram",
                    value: patientData.homeo_electriohomeogram || "-",
                  },
                  {
                    label: "Stress Test",
                    value: patientData.homeo_stress_test || "-",
                  },
                  {
                    label: "Echohomeogram",
                    value: patientData.homeo_echohomeogram || "-",
                  },
                  {
                    label: "Scan Type",
                    value: patientData.homeo_scan_type || "-",
                  },
                ].map((item, index) => (
                  <div className="col-md-3 mb-3" key={index}>
                    <div className="rounded p-1 bg-light">
                      {item.label} : <strong>{item.value}</strong>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Return Button */}
        <div className="text-center mt-4">
          <button
            type="button"
            className="btn btn-dark text-white px-4 py-2"
            onClick={handleBack}
          >
            Return to Patients
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewPatient;
